import Modal from 'components/Modal'
import EVoucherRedemptionTx from 'views/MemberProfile/ManualTx/EVoucherRedemptionTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalEVoucherRedemptionTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <EVoucherRedemptionTx onClose={onClose} />
    </Modal>
  )
}

export default ModalEVoucherRedemptionTx
